module.exports = __webpack_public_path__ + "static/media/chat-chat-doctor-male@3x.227a4af6.png";